import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BANNERS_FEATURE_KEY, BannersState } from './banners.reducer';

export const bannersState = createFeatureSelector<BannersState>(BANNERS_FEATURE_KEY);
export const banners = createSelector(bannersState, (state: BannersState) => state.banners);
